import settings from '../config';

export const is_debug = () => {
  let debug_url = !!window && !!window.location.search.match('debug=true');
  let debug_env = false;

  if (!!settings) {
    debug_env = settings.debug === true;
  }

  return debug_url || debug_env;
};

export const debug = (...params) => {
  if (is_debug()) {
    console.log(...params);
  }
};
